import {Component, EventEmitter, Inject, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TranslationService} from '@spartacus/core';
import {first} from 'rxjs';
import {IDefaultModalService} from '../../../interfaces';
import {serviceProviderTokens} from '../../../token/tokens';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator-leave-page-confirmation-modal',
  templateUrl: './dcp-configurator-leave-page-confirmation-modal.component.html',
  styleUrl: './dcp-configurator-leave-page-confirmation-modal.component.scss',
  standalone: false,
})
export class DcpConfiguratorLeavePageConfirmationModalComponent {
  private modalTitleKey = 'configurator.leavePageModal.headline';
  private modalId: string | undefined = '';

  @Input()
  set open(openModal: boolean) {
    if (openModal) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
  @Output() continueAction = new EventEmitter<void>();
  @Output() cancelAction = new EventEmitter<void>();

  @ViewChild('modalContentTemplate') modalContentTemplate!: TemplateRef<any>;

  constructor(
    @Inject(serviceProviderTokens.DEFAULT_MODAL_SERVICE_PROVIDER) private modalService: IDefaultModalService,
    private translationService: TranslationService,
  ) {}

  openModal() {
    this.translationService
      .translate(this.modalTitleKey)
      .pipe(first(), untilDestroyed(this))
      .subscribe((titleTranslation) => {
        setTimeout(() => {
          this.modalId = this.modalService.openModal(this.modalContentTemplate, titleTranslation);
        });
      });

    this.modalService
      .onClose()
      .pipe(first(), untilDestroyed(this))
      .subscribe(() => this.cancelAction.emit());
  }

  closeModal() {
    if (this.modalId) {
      this.modalService.closeModal(this.modalId);
    }
  }

  onCancel() {
    this.cancelAction.emit();
  }

  onContinue() {
    this.continueAction.emit();
  }
}
